import { Row, Col, Card, message, Table, Tabs, Typography } from "antd";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import { useNavigate, useSearchParams } from "react-router-dom";
import SearchBox from "../../components/SearchBox";
import Fyassign from "../../components/FYAssign/fyAssign";
import FYPrioritySelector from "../../components/prioritySelector";
import FYStatusSelector from "../../components/FYStatus";
import { user_role, priority_order, fy_status_order, periodTypes, financialYearTypes } from "../../consts";
import { useGetAllFinancialYears, useGetAllUsers, useUpdateFinancialYear } from "../../utils/queryUtils";
import { setSelectedClient } from "../../store/action/selected";
import { setReloadClient, setReloadFinancialYear } from "../../store/action/reload";
import { normalizeString } from "../../utils/pathUtils";

import OverviewSection from "../OverviewSection";
import { useIsPrimaryClientView } from "../../utils/useIsPrimaryClientView";

export default function Home() {
  const navigate = useNavigate();
  let dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get("tab") || "open";

  const [fyy, setFyy] = useState("");
  const placeholder = "Search Entities...";
  const [show, setShow] = useState([]);
  const [flatData, setFlatData] = useState([]);
  const [dataLength, setDataLength] = useState(0);
  const { company } = useSelector((st) => st.selected)
  const { role } = useSelector((st) => st.user);
  const { _id: selectedCompanyId } = company
  const [fy, setFy] = useState([]);
  const [firstClick, setfirstClick] = useState(true);
  const selectedPrimaryClient = useSelector(st => st.selected.primaryClient);
  const { isReadOnly } = useIsPrimaryClientView();
  console.log(isReadOnly,'fdfdj')

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [, setPageSize] = useState(10);
  const [tableFilters, setTableFilters] = useState({
    "entity": [],
    "priority": [],
    "assigned_to": [],
    "period_type": [],
    "fy_type": [],
    status: activeTab === 'open' ? ['OPEN', 'QUERIES PENDING', 'QUERIES RESOLVED'] : ['CLOSED'],
    openStatus: ['OPEN', 'QUERIES PENDING', 'QUERIES RESOLVED']
  });
  const { reloadClient, reloadFY } = useSelector(st => {
    return st.reload
  })
  const priorityFilters = priority_order.map((e) => ({ text: e, value: e }))
  const statusFilters = fy_status_order?.filter(data => data !== 'CLOSED').map((e) => ({ text: e, value: e }));
  const periodFilters = periodTypes?.map((e) => ({ text: e, value: e }));
  const fyTypeFilters = financialYearTypes?.map((e) => ({ text: e, value: e }));
  const a = useGetAllUsers();
  const all_users = a?.data?.data
  const assigneeFilters = (dat) => {
    const filteredUsers = all_users?.filter((e) =>
      e.role === user_role.ADMIN ||
      e.company_ids?.some((f) => f._id === selectedCompanyId)
    );
    let map = {};
    let filter = [];

    filteredUsers?.forEach((e) => {
      let name = `${e.first_name} ${e.last_name}`;
      let id = e._id;
      if (!map[name]) {
        map[name] = 1;
        filter.push({ text: name, value: id });
      }
    });
    return filter;
  };
  const getfinancialyear = useGetAllFinancialYears(null,
    selectedCompanyId,
    pagination.current,
    tableFilters, selectedPrimaryClient);
  const { data, isLoading, isFetching } = getfinancialyear;
  const loading = isLoading || isFetching;
  useEffect(() => {
    if (data) {
      setPagination((prev) => ({
        ...prev,
        current: data.pagination.current,
        total: data.pagination.total,

      }
      ));
      setFy(data?.data);
    }
  }, [data, fy]);

  useEffect(() => {
    if (reloadFY || reloadClient || selectedPrimaryClient) {
      getfinancialyear.refetch()
      dispatch(setReloadFinancialYear(false));
      dispatch(setReloadClient(false));
    }
  }, [reloadClient, reloadFY, selectedPrimaryClient]);

  const user = useSelector((st) => st.user);


  const { mutateAsync: updateFinancialYear } = useUpdateFinancialYear();


  const columns = [
    {
      title: `Entity (${dataLength})`,
      dataIndex: "title",
      key: "entity",
      render: (text, record) => {
        return <span className="pointer">{record.client?.title}</span>;
      },
      sorter: (a, b) => {
        a = a.title;
        b = b.title;
        return `${a?.toLowerCase()}` > `${b?.toLowerCase()}` ? 10 : -10;
      },
      // filters: entityFilters(show),
      onCell: (record) => {
        return {
          onClick: (event) => {
            dispatch(setSelectedClient(record?.client))
            navigate(
              `${normalizeString(record?.client?.title + ":" + record?.client?.abn)}/${moment(record?.start).format('YYYY')}:${moment(record?.end).format('YYYY')}:${normalizeString(record?.fy_type)}:${normalizeString(record?.period_type)}`
            );
          },
        };
      },
      onFilter: (value, record) => record.title === value,
    },
    {
      title: `Financial Year`,
      key: "financialYear",
      render: (record) => (
        <span style={{ fontWeight: "600" }} className="pointer">
          {moment(record.start).format("YYYY")} -{" "}
          {moment(record.end).format("YY")}
        </span>
      ),
      sorter: (a, b) => {
        const aa = moment(a.start);
        const bb = moment(b.start);
        return aa.isAfter(bb) ? 10 : -10;
      },
      onCell: (record) => {
        return {
          onClick: (event) => {
            // dispatch(changeSelectedClient(changedClient));
            dispatch(setSelectedClient(record?.client))
            // dispatch(changeSelectedFY(changedFY));
            navigate(
              `${normalizeString(record?.client?.title + ":" + record?.client?.abn)}/${moment(record?.start).format('YYYY')}:${moment(record?.end).format('YYYY')}:${normalizeString(record?.fy_type)}:${normalizeString(record?.period_type)}`
            );
          },
        };
      },
    },
    {
      title: "Last Updated (Date)",
      key: "lastQueryAdded",
      render: (record) => (
        <>
          <span className="pointer">
            {" "}
            {record?.latest ? (
              moment(record?.latest).format("DD/MM/YYYY")
            ) : (
              <p
                style={{
                  color: "grey",
                }}
              >
                No Update
              </p>
            )}
          </span>
        </>
      ),
      sorter: (a, b) => {
        const aa = moment(a.latest);
        const bb = moment(b.latest);
        return aa.isBefore(bb) ? -10 : 10;
      },
    },
    {
      title: "Priority",
      key: "priority",
      // sorter: (a, b) => {
      //   const aa = priority_order.indexOf(a?.priority);
      //   const bb = priority_order.indexOf(b?.priority);
      //   return aa - bb;
      // },
      sorter: false,
      render: (record) => (
        <FYPrioritySelector
          item={{
            _id: record?.fy_id,
            priority: record?.priority,
            client_id: record?.client?._id,
            company_id: record?.client?.company,
          }}
          handlePriorityUpdate={handlePriorityUpdate}
          isDisabled={user.role === user_role.COMPANY || isReadOnly}
        />
      ),
      defaultFilteredValue: tableFilters?.priority,
      filters: priorityFilters,
      filterMultiple: true,
      onFilter: (value, record) => record.priority === value,
    },
    {
      title: "Status",
      key: "status",
      sorter: false,
      render: (record) => (
        <FYStatusSelector
          item={{
            _id: record?.fy_id,
            status: record?.status,
            client_id: record?.client?._id,
            company_id: record?.client?.company,
          }}
          handleStatusUpdate={handleStatusUpdate}
          isDisabled={user.role === user_role.COMPANY || isReadOnly}
        />
      ),
      filters: activeTab === "open" ? statusFilters : null,
      filterMultiple: true,
      onFilter: (value, record) => record.status === value,
    },
    {
      title: "Period Type",
      key: "period_type",
      dataIndex: "period_type",
      sorter: false,
      filters: periodFilters,
      filterMultiple: true,
      render: (value) => value,
      onFilter: (value, record) => record.period_type === value

    },
    {
      title: "FY Type",
      key: "fy_type",
      dataIndex: "fy_type",
      sorter: false,
      filters: fyTypeFilters,
      filterMultiple: true,
      render: (value) => value,
      onFilter: (value, record) => record.fy_type === value

    },
    {
      title: "Assigned To",
      key: "assigned_to",
      render: (record) => (
        <div
          style={{ display: "flex", alignItems: "center", gap: "10px" }}
          onClick={() => setFyy(record?.fy_id)}
        >
          <Fyassign
            query={{
              assigned_to: {
                first_name: record?.first_name,
                last_name: record?.last_name,
              },
            }}
            className="p-2"
            handleFyUpdate={handleFyUpdate}
            role={""}
            firstClick={firstClick}
            setfirstClick={setfirstClick}
            disabled={isReadOnly}
          />
        </div>
      ),
      defaultFilteredValue: tableFilters?.assigned_to,
      filters: assigneeFilters(show),
      filterMultiple: true,
      // onFilter: (value, record) =>{
      //   console.log(record?.assigned_to?._id === value?.assigned_to?._id,record  ,value )
      //   return record?.assigned_to?._id === value?.assigned_to?._id
      // }
    },
  ];

  const handleTableChange = (pagination, newFilters, sorter) => {
    setPagination((prev) => ({
      ...prev,
      current: pagination?.current
    }));
    setPageSize(pagination?.pageSize);
    setTableFilters((prev) => {
      if (!newFilters?.status?.length) {
        newFilters.status = activeTab === 'open' ? ['OPEN', 'QUERIES PENDING', 'QUERIES RESOLVED'] : ['CLOSED']
        newFilters.openStatus = prev?.openStatus ? prev?.openStatus : ['OPEN', 'QUERIES PENDING', 'QUERIES RESOLVED']
      }
      else if (newFilters?.status?.length) {
        newFilters.status = activeTab === 'open' ? newFilters?.status : ['CLOSED']
        newFilters.openStatus = newFilters?.status.includes('CLOSED') ? prev?.openStatus : newFilters?.status
      }
      return prev = { ...prev, ...newFilters }
    });
  };

  const callbackTabClicked = (key) => {
    const newTab = key === "tab1" ? "open" : "closed";
    setSearchParams({ tab: newTab });
    setTableFilters((prev) => {
      if (newTab === "open") {
        if (!prev?.status?.length || (prev?.status?.length && prev?.status?.includes('CLOSED'))) {
          return { ...prev, status: prev?.openStatus }
        }
        return prev;
      }
      else {
        return prev = { ...prev, status: ['CLOSED'] }
      }
    })
  };

  useEffect(() => {
    if (fy) {
      handleDataChange(activeTab === "open");
    }
  }, [fy, activeTab, tableFilters]);

  function handleDataChange(t = true) {
    try {
      let temp = fy
        ?.map((item) => {
          // let latest = item.updatedAt;
          return {
            start: item?.start,
            end: item?.end,
            fy_id: item?._id,
            priority: item?.priority,
            status: item?.status,
            first_name: item?.assigned_to?.first_name,
            last_name: item?.assigned_to?.last_name,
            userId: item?.assigned_to?._id,
            client: item.client,
            latest: item?.updatedAt,
            // title: client.find((e) => e._id === item.client)?.title,
            title: item?.client?.title,
            period_type: item?.period_type,
            fy_type: item?.fy_type
          };
        }
        )
        .filter((item, i) => {
          return item?.client && (t ? item.status !== "CLOSED" : item.status === "CLOSED")
        }
        )
        .sort((a, b) => {
          if (a.title?.toUpperCase() < b.title?.toUpperCase()) {
            return -1;
          }
          if (a.title?.toUpperCase() > b.title?.toUpperCase()) {
            return 1;
          }
          const aa = moment(a.start).format("LL");
          const bb = moment(b.start).format("LL");
          return `${aa?.toLowerCase()}` > `${bb?.toLowerCase()}` ? 10 : -10;
        });
      setShow((prev) => {
        prev = temp
        return prev
      });
      setDataLength(temp.length);
      setFlatData(temp);
    } catch (e) {
      console.error(e);
    }
  }

  const handleFyUpdate = async (update) => {
    try {
      const payload = {
        ...update,
        // clientName: item.client_id,
        companyName: selectedCompanyId,
        page: pagination.current,
        filters: tableFilters,
        fy: fyy,
        all: true
      };
      await updateFinancialYear(payload)

    } catch (e) {
      console.error(e);
      message.error("Some error occurred while updating assigned to");
    }
  };

  const handlePriorityUpdate = async (item, newPriority) => {
    if (item.priority !== newPriority) {
      try {
        const payLoad = {
          fy: item._id,
          priority: newPriority,
          clientName: item?.client_id,
          companyName: item?.company_id,
          page: pagination.current,
          filters: tableFilters,
          all: true
        };
        await updateFinancialYear(payLoad);
      } catch {
        message.error("Some error occurred while updating priority");
      }
    }
    return;
  };

  const handleStatusUpdate = async (item, newStatus) => {
    if (item.status !== newStatus) {
      try {
        const payLoad = {
          fy: item._id,
          status: newStatus,
          clientName: item?.client_id,
          companyName: item?.company_id,
          page: pagination.current,
          filters: tableFilters,
          all: true
        };
        await updateFinancialYear(payLoad);

        dispatch(setReloadFinancialYear(true))
      } catch {
        message.error("Some error occurred while updating status");
      }
    }
    return;
  };

  return (
    <>
      <div>
        {role === user_role.PRIMARY_CLIENT && (
          <OverviewSection Total_Entities={dataLength} />
        )}
        <div>
          <Tabs
            type="card"
            onTabClick={callbackTabClicked}
            activeKey={activeTab === "open" ? "tab1" : "tab2"}
          >
            <items
              tab={
                <Typography.Title level={5} className="align-self-start">
                  <div className="flex-fill search d-flex">
                    <span className="me-3">Open Financial Years</span>
                  </div>
                </Typography.Title>
              }
              key="tab1"
            >

            </items>
            <items
              tab={
                <Typography.Title level={5} className="align-self-start">
                  Closed Financial Years
                </Typography.Title>
              }
              key="tab2"
            >

            </items>
          </Tabs>
          <div className="table-responsive">
            <Row gutter={[24, 0]}>
              <Col xs={24} className="mb-24">
                <Card
                  className="header-solid h-full"
                  variant="borderless"
                  title={[
                    <div className="d-flex">
                      <div className="flex-fill search d-flex">
                        <div className="d-flex flex-fill justify-content-center">
                          <SearchBox
                            all={flatData}
                            setshow={setShow}
                            name={placeholder}
                            setFilter={setTableFilters} filterKey={'title'}
                          />
                        </div>
                      </div>
                    </div>,
                  ]}
                  style={{ body: { paddingTop: "0" } }}
                >
                  <Table
                    columns={columns}
                    dataSource={show}
                    loading={loading}
                    pagination={{
                      current: pagination?.current,
                      pageSize: pagination?.pageSize,
                      total: pagination?.total,
                      showSizeChanger: false,
                    }}
                    sortDirections={["descend", "ascend"]}
                    size="small"

                    // onChange={(pagination, filters, sorter, extra) => {
                    //   setDataLength(extra.currentDataSource.length);
                    // }}
                    onChange={handleTableChange}
                  />
                </Card>
              </Col>
            </Row>
          </div>
        </div>
      </div>

    </>
  );
}